import { FiCheck } from "react-icons/fi";
import {
	STEP_STATES,
	STEP_CIRCLE_CLASSES,
	STEP_STATE_LABELS,
} from "./stepStyles";

interface StepperLegendProps {
	/** Override the wrapper classes (e.g. to drop the default bottom margin
	 * when placing the legend in a header row). */
	className?: string;
}

/**
 * Legend explaining the three stepper states (PRO-526). Swatches reuse the
 * same circle classes as the rendered steps so they always stay in sync.
 */
export const StepperLegend: React.FC<StepperLegendProps> = ({
	className = "flex flex-wrap items-center gap-4 mb-4",
}) => {
	return (
		<div
			className={`relative ${className}`}
			role="list"
			aria-label="Step status legend"
		>
			{STEP_STATES.map((state) => (
				<div key={state} className="flex items-center gap-2" role="listitem">
					<span
						className={`flex items-center justify-center w-5 h-5 rounded-full flex-shrink-0 ${STEP_CIRCLE_CLASSES[state]}`}
					>
						{state === "completed" && <FiCheck size={12} />}
					</span>
					<span className="text-xs text-primary-600">
						{STEP_STATE_LABELS[state]}
					</span>
				</div>
			))}
		</div>
	);
};
